import { LegalPage } from "../components/LegalPage";

export default function Privacy() {
  return <LegalPage i18nKey="privacy" />;
}
